import { db } from "@db";

export type FeatureUsageRecord = {
  featureId: string;
  usedAt: Date;
};

export async function getAllFeatureUsage(): Promise<FeatureUsageRecord[]> {
  return db.featureUsage.toArray();
}

export async function putFeatureUsage(record: FeatureUsageRecord) {
  await db.featureUsage.put(record);
}

export async function clearFeatureUsage() {
  await db.featureUsage.clear();
}
